import { isProdOrDevServer } from '@utils/is-prod-server';

const isProdOrDev = isProdOrDevServer();

export const getTimeZone = (date: Date | string): string => {
  const dateStr = (date || '').toString();
  const isZeroTime = dateStr
    && (dateStr.includes('00:00:00.000') || dateStr.includes(':00:00 GMT') || /^\d{4}-\d{2}-\d{2}$/.test(dateStr));
  const timeZone = isProdOrDev && !isZeroTime ? 'America/Mexico_City' : 'Etc/UTC';

  return timeZone;
};

class DateFormatter {

  toDateTime(dateTime: string | null | undefined, withYear = false): string | null {
    if (!dateTime) return null;
    return new Date(dateTime).toLocaleString([], {
      timeZone: getTimeZone(dateTime),
      day: '2-digit',
      month: 'short',
      year: withYear ? 'numeric' : undefined,
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  }

  toTime(dateTime: Date | string, hour12 = false): string {
    return new Date(dateTime).toLocaleString([], {
      timeZone: getTimeZone(dateTime),
      hour: '2-digit',
      minute: '2-digit',
      hour12,
    });
  }

  toDate(dateTime: string) {
    return new Date(dateTime).toLocaleString([], {
      timeZone: getTimeZone(dateTime),
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  }

  toDateSlash(date?: Date | string | null | undefined, withTime = false): string | null {
    if (!date) {
      return null;
    }
    const { day, month, year } = this.getDayMonthYear(date);

    if (withTime) {
      const hourMinues = this.toTime(date, false);
      return `${day}/${month}/${year} ${hourMinues}`;
    }

    return `${day}/${month}/${year}`;
  }

  dateToDbFormat(date?: Date | string): string {
    const { day, month, year } = this.getDayMonthYear(date);

    return `${year}-${month}-${day}`;
  }

  getDayMonthYear(date?: Date | string): {
    day: string;
    month: string;
    year: string;
  } {
    let d: Date = new Date();

    if (typeof date === 'string') {
      const parts = date.split('/');
      const dotParts = date.split('.');
      if (parts[2] && parts[2].length === 4) {
        d = new Date(+parts[2], +parts[1] - 1, +parts[0]);
      } else if (dotParts[2] && dotParts.length === 4) {
        d = new Date(+dotParts[2], +dotParts[1] - 1, +dotParts[0]);
      } else {
        d = new Date(date);
      }
    }

    const timeZone = getTimeZone(d);
    d = new Date(d.toLocaleString('en', { timeZone }));

    let month = String(d.getMonth() + 1);
    let day = String(d.getDate());
    const year = String(d.getFullYear());

    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;

    return { day, month, year };
  }

  parseToMin(timeStr: string): number {
    if (!timeStr) return 0;

    let totalMinutes = 0;

    const patterns = {
      d: 24 * 60, // дни
      h: 60, // часы
      m: 1, // минуты
    };

    const regex = /(\d+)\s*([dhm])/g;
    let match;

    while ((match = regex.exec(timeStr)) !== null) {
      const value = parseInt(match[1], 10);
      const unit = match[2];
      totalMinutes += value * patterns[unit];
    }

    return totalMinutes;
  }
}

export const dateFormatter = new DateFormatter();
